const scrollSnoop = require('./scroll-snoop.cjs');

const easeIntoView = function easeIntoView() {
  // Elements slide up as they come into the viewport
  let running = false;

  const isWithinBounds = function isWithinBounds() {
    let easeElements = [].slice.call(document.querySelectorAll('[data-ease-in]'));

    if (easeElements.length < 1 || running) return;

    running = true;
    setTimeout(() => {
      easeElements.forEach((element) => {
        if ((0, scrollSnoop.default)(element)) {
          element.classList.add('visible');

          easeElements = easeElements.filter((active) => (active !== element));
        }
      });
      running = false;
    }, 200);
  };

  window.addEventListener('resize', isWithinBounds);
  window.addEventListener('orientationchange', isWithinBounds);
  document.addEventListener('scroll', isWithinBounds);
  document.addEventListener('ease:update', isWithinBounds);
  isWithinBounds();
};

exports.default = easeIntoView;